import { useLoaderData } from '@remix-run/react';
import { WebRoutes } from '@theprintbar/shared';
import { Carousel, ProductTile } from '@theprintbar/ui';
import { loader } from '~/routes/_layout/$/_index';

interface ProductCarouselProps {
	carouselKey?: string;
}

export function ProductCarousel3({ carouselKey = 'product-carousel-3' }: ProductCarouselProps) {
	const { products3, productsDecoration, productsSameday } = useLoaderData<typeof loader>();

	return products3 ? (
		<div>
			<Carousel
				carouselKey={carouselKey}
				slidesPerView="auto"
				className="px-2 lg:px-4"
				slides={products3.map(p => ({
					containerProps: {
						className: 'px-2 lg:px-4 max-w-56 lg:max-w-80',
					},
					content: (
						<div className="h-full w-full relative mt-4">
							<ProductTile
								params={{ sameday: !!productsSameday, decoration: productsDecoration || undefined }}
								product={p}
								productPath={WebRoutes.Product(p.slug)}
								calculator={WebRoutes.Calculator(p.code)}
							/>
						</div>
					),
				}))}
			/>
		</div>
	) : null;
}
